import React, { useState, useEffect } from "react";
import "./index.scss";
import wallet from "../../assests/images/recharge-wallet.svg";
import balance from "../../assests/images/balance.svg";
import waveBackground from "../../assests/images/wave-background.svg";
import { Row, Col, Modal, Button, Input, message, Radio } from "antd";
import API from "../../api";
import urls from "../../api/urls";
import { ReloadOutlined } from "@ant-design/icons";
const { GET_WALLET_BALANCE, RECHARGE_WALLET, GET_WALLET_TRANSACTIONS } = urls;

const WalletBalanceCard = ({ reloadTable = () => {}, prospayCustomerId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  const quickAmounts = [500, 2000, 5000, 10000];
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [transactionType, setTransactionType] = useState("credit");
  const [description, setDescription] = useState("");
  useEffect(() => {
    if (prospayCustomerId) {
      getWalletBalance();
    }
  }, [prospayCustomerId]);

  const getWalletBalance = async () => {
    setIsRefreshing(true);
    // const prospayCustomerId =
    //   JSON.parse(localStorage.getItem("selectedCompany"))?.prospayCustomerId ||
    //   null;
    // const prospayCustomerId = "SMLNBA000000000603325";

    const response = await API.Api(
      GET_WALLET_BALANCE + prospayCustomerId
    ).getWithToken();
    if (response?.status) {
      setIsRefreshing(false);
      setWalletBalance(response?.response?.data?.data?.points || 0);
    } else {
      setIsRefreshing(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const handleQuickAmountSelect = (amount) => {
    setRechargeAmount(amount);
  };

  const postRecharge = async () => {
    if (!rechargeAmount) {
      message.error("Please enter a valid amount");
      return;
    }
    // const prospayCustomerId =
    //   JSON.parse(localStorage.getItem("selectedCompany"))?.prospayCustomerId ||
    //   null;

    const payload = {
      amount: parseFloat(rechargeAmount),
      txnType: "bill-payment", //payment-txn// //wallet-recharge//
      redirectURL: window.location.href,
      customerId: prospayCustomerId,
      description: "payment-txn",
    };
    const response = await API.Api(RECHARGE_WALLET).post(payload);

    if (response?.status) {
      window.open(response?.response?.data?.data?.url, "_blank");
      setIsModalOpen(false);
      setRechargeAmount("");
      setDescription("");
      //message.success("Recharge successful");
    } else {
      message.error(
        response?.response?.data?.message || "Internal Server Error"
      );
    }
  };

  const updateRecharge = async () => {
    if (!rechargeAmount) {
      message.error("Please enter a valid amount");
      return;
    }
    const payload = {
      amount: parseFloat(rechargeAmount),
      txnType: transactionType,
      description: description,
    };
    const response = await API.Api(
      GET_WALLET_TRANSACTIONS + prospayCustomerId
    ).patch(payload);
    if (response?.status) {
      setIsModalOpen(false);
      setRechargeAmount("");
      setDescription("");
      reloadTable();
      getWalletBalance();
      //message.success("Recharge successful");
    } else {
      message.error(
        response?.response?.data?.message || "Internal Server Error"
      );
    }
  };
  return (
    <>
      {/* <p>My Wallet</p> */}
      <Row>
        <Col span={12}>
          <div
            className="wallet-card"
            style={{
              backgroundImage: `url(${waveBackground})`,
            }}
          >
            <div className="card-body space-between align-center p-4">
              <div>
                <div className="balance-text center">
                  <img src={balance} alt="balance" className="mr-1" />
                  <span className="fw-600">Balance</span>
                </div>
                <div className="balance-amount mt-05">
                  ₹ {walletBalance}{" "}
                  <ReloadOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                      getWalletBalance();
                      reloadTable();
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "18px",
                      color: "#1890ff",
                      transition: "all 0.3s",
                    }}
                    spin={isRefreshing}
                  />
                </div>
              </div>
              <Button
                className="wallet-button"
                onClick={() => setIsModalOpen(true)}
              >
                <img src={wallet} alt="recharge-wallet" />
                {history?.state?.usr?.prospayCustomerId
                  ? "Rebalance"
                  : "Recharge Wallet"}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Modal
        title={
          history?.state?.usr?.prospayCustomerId
            ? "Rebalance"
            : "Recharge Wallet"
        }
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setRechargeAmount("");
          setDescription("");
        }}
        footer={null}
        className="recharge-modal"
        width={500}
      >
        <div className="recharge-modal-content p-05">
          {history?.state?.usr?.prospayCustomerId && (
            <>
              <div className="transaction-type">
                {/* <p style={{ marginBottom: 0 }}>Transaction Type</p> */}
                <Radio.Group
                  value={transactionType}
                  onChange={(e) => setTransactionType(e.target.value)}
                  style={{ marginBottom: "10px" }}
                >
                  <Radio value="credit">Credit</Radio>
                  <Radio value="debit">Debit</Radio>
                </Radio.Group>
              </div>
            </>
          )}
          <Input
            type="number"
            value={rechargeAmount}
            onChange={(e) => setRechargeAmount(e.target.value)}
            placeholder="Enter recharge amount"
            prefix="₹"
            style={{ borderRadius: "6px", height: "40px" }}
          />

          <div className="quick-amounts mt-05">
            <p>Select Quick Recharge</p>
            <Row gutter={[8, 8]}>
              {quickAmounts.map((amount) => (
                <Col span={6} key={amount}>
                  <Button
                    block
                    onClick={() => handleQuickAmountSelect(amount)}
                    style={{ borderRadius: "6px" }}
                  >
                    ₹{amount}
                  </Button>
                </Col>
              ))}
            </Row>
          </div>
          {history?.state?.usr?.prospayCustomerId && (
            <>
              <div className="transaction-type mt-05">
                <p style={{ marginBottom: "5px" }}>Description</p>
                <Input.TextArea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                />
              </div>
            </>
          )}

          <div className="recharge-summary mt-1">
            <h4 className="summary-heading">Recharge Summary</h4>
            <div className="summary-item">
              <span>Recharge Amount</span>
              <span>₹{rechargeAmount || 0}</span>
            </div>
            {/* <div className="summary-item">
              <span>Cashback</span>
              <span>₹0</span>
            </div>
            <div className="summary-item">
              <span>Transaction Fee</span>
              <span>₹0</span>
            </div> */}
            <div className="summary-divider" />
            <div className="summary-item">
              <span style={{ color: "#3C3C3C" }}>Total Amount</span>
              <span style={{ color: "#3C3C3C" }}>₹{rechargeAmount || 0}</span>
            </div>
          </div>

          <Button
            className="mt-1 save-btn w-100"
            onClick={() => {
              history?.state?.usr?.prospayCustomerId
                ? updateRecharge()
                : postRecharge();
            }}
            style={{ height: "40px" }}
          >
            {history?.state?.usr?.prospayCustomerId
              ? "Rebalance Now →"
              : "Recharge Now →"}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default WalletBalanceCard;
